import { Card, CardContent, CardHeader, Divider, Stack, Typography, Box } from '@mui/material';
import ErrorMessage from '../errorMessage';
import { useElementSize } from '@custom-react-hooks/use-element-size';
import XMLViewer from 'react-xml-viewer';

type Props = {
  xmlContent: string;
  maxHeight?: number;
  showLabel?: boolean;
  label?: string;
  error?: string;
};

const XmlFileViewer = ({ xmlContent, showLabel = true, label, error, maxHeight = 0 }: Props) => {
  const [headerRef, headerSize] = useElementSize();

  const computedHeight =
    maxHeight > 0
      ? `${Math.max(80, maxHeight - (headerSize.height > 0 ? headerSize.height + 1 : 0))}px`
      : 'auto';

  return (
    <Card variant="outlined" sx={{ border: label || error ? 1 : 0, borderColor: 'divider', width: '100%', maxWidth: '100%' }}>
      {showLabel && (label || error) && (
        <CardHeader
          title={
            <Stack direction="row" spacing={2} justifyContent="space-between" alignItems={'center'}>
              <Typography sx={{ textOverflow: 'ellipsis', fontWeight: 600, fontSize: '0.8rem' }}>{label}</Typography>
            </Stack>
          }
          subheader={error && <ErrorMessage error={error} />}
          sx={{ p: 1 }}
          ref={headerRef}
          disableTypography
        />
      )}
      {showLabel && (label || error) && <Divider />}
      <CardContent sx={{ overflow: 'auto', maxHeight: maxHeight > 0 ? computedHeight : 'none', p: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Box sx={{ width: '100%', maxWidth: '100%', overflow: 'auto', fontSize: '0.8rem' }}>
          <XMLViewer xml={xmlContent || ''} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default XmlFileViewer;
